import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { DELETE, GET } from "../../../utils/apiCalls";
import API from "../../../config/api";
import Loading from "../../../components/loading";
import DataTable from "./dataTable";
import { Button, Card, message, Select } from "antd";
import MailForm from "./form";

function MailTemplate() {
  const [loading, setLoading] = useState(true);
  const [tableLoading, setTableLoading] = useState(false);
  const [data, setData] = useState([]);
  const [type, setType] = useState<string>("");
  const [isInitialLoad, setIsInitialLoad] = useState(true);
  const Events = useSelector((state: any) => state.Events);
  const user = useSelector((state: any) => state.User.user);

  const [selectedItem, setSelectedItem] = useState<any>({});
  const [openForm, setOpenForm] = useState(false);

  useEffect(() => {
    getData();
  }, [type]);

  const getData = async () => {
    // Only show full loading on initial load, table loading on filter changes
    if (isInitialLoad) {
      setLoading(true);
    } else {
      setTableLoading(true);
    }
    try {
      let api = API?.MAIL_TEMPLATE_LIST + `${Events?.defult?.id}`;
      const params = type ? { type } : null;
      const response: any = await GET(api, params);
      if (response?.status) {
        const filteredData = response?.data?.filter((item: any) => item?.type !== 'meeting') || [];
        setData(filteredData);
        setLoading(false);
        setTableLoading(false);
        setIsInitialLoad(false);
      } else {
        setData([]);
        setLoading(false);
        setTableLoading(false);
        setIsInitialLoad(false);
      }
    } catch (err) {
      setData([]);
      setLoading(false);
      setTableLoading(false);
      setIsInitialLoad(false);
    }
  };

  const editItem = (value: any) => {
    setSelectedItem(value);
    setOpenForm(!openForm);
  };

  const deleteItem = async (id: any) => {
    try {
      let response: any = await DELETE(API.MAIL_TEMPLATE_DELETE + id);
      if (response?.status) {
        getData();
        message.error("Deleted");
      } else {
        message.error("Oops.something gone wrong.");
      }
    } catch (err) {
      message.error("Oops.something gone wrong.");
    }
  };

  return (
    <div>
      <Card
        title={"Email Templates"}
        extra={[
          <div className="settingScreen-pageHeader" style={{ marginTop: 10 }}>
              {Array.isArray(user.access[Events?.defult?.id]) &&
               user.access[Events?.defult?.id].includes(8) ? null :
               <>
               <Select 
                 style={{ marginRight: 8, width: 220 }}
                 placeholder="Filter by type"
                 allowClear
                 value={type || undefined}
                 onChange={(value) => setType(value || "")}
                 options={[
                  { value: 'custom', label: 'Custom Templates' },
                  { value: 'acknowledge', label: 'Acknowledge Templates' },
                  { value: 'notification', label: 'Notification Templates' },
                 ]}
              />
              <Button type="primary" onClick={() => setOpenForm(true)}>
              Add New +{" "}
            </Button>
                </>
        }
          </div>,
        ]}
      >
        {loading ? (
          <Loading />
        ) : (
          <DataTable
            data={data}
            loading={tableLoading}
            delete={(id: any) => deleteItem(id)}
            onChange={(value: any) => editItem(value)}
            onStatusChange={() => getData()}
          />
        )}
      </Card>
      {openForm ? (
        <MailForm
          visible={openForm}
          data={selectedItem}
          onClose={() => editItem({})}
          onChange={() => getData()}
        />
      ) : null}
    </div>
  );
}

export default MailTemplate;
